import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=acd3d5c6"
import script from "./DetailsPanel.vue?vue&type=script&lang=ts"
export * from "./DetailsPanel.vue?vue&type=script&lang=ts"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=acd3d5c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports